export default {
  contract: {
    provider: {
      reference: 'Ref. contrato'
    },
    reference: 'Referência do contrato'
  },
  customInvoice: {
    inscription: 'Inscrição no Registro Mercantil'
  },
  contact: {
    reference: 'Adicionar referência de contrato',
    customization: 'Personalização da fatura',
    aditional: 'Informações adicionais solicitadas pelo pagador'
  },
  invoiceData: {
    requiredFields: '(*) Campos obrigatórios',
    general: 'Dados gerais',
    modify: 'Modificar dados',
    modifyContactData: 'Modificar dados de contato',
    search: 'Buscar na Agenda',
    manualAdd: 'Adicionar manualmente',
    equalToClient: 'Dados do comprador iguais aos do cliente',
    updateProviderData: 'Atualizar dados',
    updatedProviderData: 'Dados do fornecedor atualizados com sucesso'
  }
}